module.exports = __webpack_public_path__ + "img/badge-fastest-lead-pickup-gold.4ce1990b.png";